import { useEffect, useState, useRef } from "react";
import { Loader2 } from "lucide-react";
import { trpc } from "../lib/trpc";

export function AdminLoginPage() {
  const [error, setError] = useState<string | null>(null);
  const hasInitiated = useRef(false);

  const samlLoginMutation = trpc.auth.samlLogin.useMutation({
    onSuccess: (data) => {
      if (data.redirectUrl) {
        window.location.href = data.redirectUrl;
      }
    },
    onError: (err) => {
      setError(err.message || "Failed to initiate SAML login");
    },
  });

  useEffect(() => {
    if (hasInitiated.current) return;
    hasInitiated.current = true;
    samlLoginMutation.mutate();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full space-y-8 p-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-foreground">
            Admin Sign In
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Redirecting to TeleCloud SSO...
          </p>
        </div>

        {error ? (
          <div className="rounded-md bg-destructive/10 border border-destructive/20 p-4">
            <h3 className="text-sm font-medium text-destructive">
              Authentication Error
            </h3>
            <p className="mt-2 text-sm text-destructive/90">{error}</p>
            <button
              type="button"
              onClick={() => { window.location.href = "/login"; }}
              className="mt-4 text-sm font-medium text-destructive hover:text-destructive/80"
            >
              Return to customer login
            </button>
          </div>
        ) : (
          <div className="flex justify-center">
            <Loader2 className="h-12 w-12 animate-spin text-primary" />
          </div>
        )}

        <div className="text-center text-sm text-muted-foreground">
          <p>TeleCloud employees only</p>
          <a href="/login" className="font-medium text-primary hover:text-primary/80">
            Customer login →
          </a>
        </div>
      </div>
    </div>
  );
}
